export interface ImageMap {
  small: string
  medium: string
  large: string
  original: string
}

export async function getImagesForProduct(
  id: string,
  variantId?: string,
): Promise<ImageMap[] | null | undefined> {
  const res = await fetch(
    `https://${
      import.meta.env.VITE_SHOPIFY_STORE
    }.myshopify.com/api/2022-10/graphql.json`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
        query Product($id: ID!) {
          product(id: $id) {
            id
            variants(first: 10) {
              edges {
                node {
                  id
                  title
                  image {
                    altText
                    small: url(transform: { maxWidth: 200 })
                    medium: url(transform: { maxWidth: 500 })
                    large: url(transform: { maxWidth: 1000 })
                    original: url
                  }
                }
              }
            }
            images(first: 1) {
              edges {
                node {
                  altText
                  width
                  height
                  small: url(transform: { maxWidth: 200 })
                  medium: url(transform: { maxWidth: 500 })
                  large: url(transform: { maxWidth: 1000 })
                  original: url
                }
              }
            }
          }
        }
      `,
        variables: {
          id: `gid://shopify/Product/${id}`,
        },
      }),
    },
  )
  if (res.ok) {
    const product = (await res.json()).data.product
    if (product) {
      if (variantId) {
        return product.variants.edges
          .filter((edge: { node: { id: string } }) => {
            if (
              variantId.toString() ===
              edge.node.id.replace('gid://shopify/ProductVariant/', '')
            ) {
              return true
            }
          })
          .map((variant: { node: { image: ImageMap } }) => variant.node.image)
      } else {
        return product.images.edges.map(
          (edge: { node: ImageMap }) => edge?.node,
        )
      }
    } else {
      return null
    }
  } else {
    return null
  }
}
